/**
 * Testimonials — Glider.js carousel with fractional offpage slides.
 * Adapted from the R55 starter's carousel-cards-offpage block.
 */
(function () {
	'use strict';

	function initCarousel($block) {
		const root = $block || document;
		const carousels = root.querySelectorAll('.testimonials .glider');

		carousels.forEach(function (carousel) {
			if (carousel.classList.contains('glider-initialized')) return;

			const id = carousel.id;
			const carouselBlock = carousel.closest('.testimonials');
			const prevBtn = carouselBlock.querySelector('.testimonials-btn-prev[data-carousel="' + id + '"]');
			const nextBtn = carouselBlock.querySelector('.testimonials-btn-next[data-carousel="' + id + '"]');

			carousel.classList.add('glider-initialized');

			const baseSlides = parseInt(carousel.getAttribute('data-slides-to-show')) || 3;
			const gliderOptions = {
				slidesToShow: baseSlides + 0.2,
				slidesToScroll: 1,
				draggable: true,
				scrollLock: true,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: baseSlides + 0.2,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 1,
						settings: {
							slidesToShow: 1.2,
							slidesToScroll: 1
						}
					}
				]
			};

			if (prevBtn && nextBtn) {
				gliderOptions.arrows = { prev: prevBtn, next: nextBtn };
			}

			const glider = new Glider(carousel, gliderOptions);
			carousel.gliderInstance = glider;

			const gliderContain = carousel.closest('.glider-contain');
			if (gliderContain) gliderContain.classList.add('glider-loaded');

			function updateState() {
				const currentSlide = glider.slide;
				const totalSlides = glider.slides.length;
				const numPages = Math.max(1, totalSlides - baseSlides + 1);

				if (prevBtn) {
					prevBtn.toggleAttribute('disabled', currentSlide === 0);
					prevBtn.setAttribute('aria-disabled', currentSlide === 0 ? 'true' : 'false');
				}
				if (nextBtn) {
					nextBtn.toggleAttribute('disabled', currentSlide >= numPages - 1);
					nextBtn.setAttribute('aria-disabled', currentSlide >= numPages - 1 ? 'true' : 'false');
				}
			}

			updateState();
			carousel.addEventListener('glider-slide-visible', updateState);
		});
	}

	// Front-end init
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			if (typeof Glider !== 'undefined') initCarousel();
		});
	} else {
		if (typeof Glider !== 'undefined') initCarousel();
	}

	// ACF block-editor preview init
	if (window.acf) {
		const hookNames = [
			'render_block_preview/type=testimonials',
			'render_block_preview/type=acf/testimonials',
			'render_block_preview'
		];

		hookNames.forEach(function (hookName) {
			window.acf.addAction(hookName, function ($block) {
				if ($block && $block[0] && $block[0].querySelector('.testimonials .glider')) {
					setTimeout(function () {
						if (typeof Glider !== 'undefined') initCarousel($block[0]);
					}, 200);
				}
			});
		});
	}
})();
